const type = 'SET_DISPUTE_SUBMITTING';

const setDisputeSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setDisputeSubmitting;
